<div class="content">
  <div class="titulo">
    <h1>{{titulo}}</h1>
    <div (click)="back()">
      <svg class="icon-close-doc">
        <use xlink:href="#icon-close"></use>
      </svg>
    </div>
  </div>
  <div class="main">
    <div class="flex-doc">
      <app-configuracion-documento-upload id="uploadDoc" (fileListEmitter)="uploadPdf($event)"  [firmanteSeleccionado]="firmanteSeleccionado" [indexPaso]="index" [src]="urlDocumento" [pdfCargado]="pdfCargado" [idDocumentoEditar]="idDocumentoEditar" [idPdf]="idPdf" (ficheroCargado)="finCarga()" (oldDocEmitter)="abrirDocAntiguo($event)" (pdfLoadComplete)="onPdfLoadComplete($event)"></app-configuracion-documento-upload>

      <div class="flex-lateral no-seleccionable">
        <div class="flex-lateral__contenido">
          <app-titulo-paso-conf-doc *ngIf="index>2" [icono]="iconoDoc" [titulo]="nombre.value"></app-titulo-paso-conf-doc>
          <app-configuracion-documento-progreso [indexStep]="index" [finalizarProceso]="finalizarProceso"></app-configuracion-documento-progreso>
          <div class="flex-lateral__paso">
            <app-configuracion-documento-ayuda-subida *ngIf="index==1"></app-configuracion-documento-ayuda-subida>
            <app-configuracion-documento-nombre *ngIf="index==2" id="cambiarDocId" (cambiarDoc)="cambiarDoc($event)"></app-configuracion-documento-nombre>
            <app-configuracion-documento-copiar-configuracion *ngIf="index==3"></app-configuracion-documento-copiar-configuracion>
            <app-configuracion-documento-firmante *ngIf="index==4" [esDocumentoEnEdicion]="!!idDocumentoEditar"></app-configuracion-documento-firmante>
            <app-configuracion-documento-texto-excluir *ngIf="index==5"></app-configuracion-documento-texto-excluir>
            <app-configuracion-documento-configurar-cif *ngIf="index==6" [idPdf]="idPdf" (cargaCifEmitter)="spinnerCifIsCargando($event)"></app-configuracion-documento-configurar-cif>
            <app-configuracion-documento-configurar-nif *ngIf="index==7" [idPdf]="idPdf" (cargaNifEmitter)="spinnerNifIsCargando($event)"></app-configuracion-documento-configurar-nif>
            <app-configuracion-documento-panel-firmantes-unificado *ngIf="index==8" (firmanteSeleccionado)="getFirmanteSeleccionado($event)" [erroresForm]="erroresForm"></app-configuracion-documento-panel-firmantes-unificado>
          </div>
        </div>
        <div class="">
          <app-configuracion-documento-botonera [index]="index" (botonClicked)="irDireccion($event)"></app-configuracion-documento-botonera>
        </div>
      </div>
    </div>
  </div>
</div>

